export default __webpack_public_path__ + "static/media/notificationIcon.d80b2291.svg";